<script setup>
import integrationAPI from 'dashboard/api/wgpt/integrations';
import Banner from 'dashboard/components/ui/Banner.vue';
import { useAlert } from 'dashboard/composables';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  hook: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const shouldShowBanner = computed(
  () => props.hook?.settings?.access_token_refresh_has_failed
);

const reauthenticate = async () => {
  try {
    const { data } = await integrationAPI.connectSalla();

    if (data.redirect_url) {
      window.location.href = data.redirect_url;
    }
  } catch (error) {
    useAlert(t('WGPT_INTEGRATIONS.SALLA.CONNECTION_ERROR'));
  }
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="t('WGPT_INTEGRATIONS.SALLA.TOKEN_FAILURE_BANNER_MESSAGE')"
    :action-button-label="t('WGPT_INTEGRATIONS.SALLA.REAUTHORIZE_BUTTON_LABEL')"
    has-action-button
    class="border-t border-n-weak"
    @primary-action="reauthenticate"
  />
</template>
